import React, { Component } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { get } from 'lodash';

export default class RowItemTheoDoiDonDocTheoKy extends Component {
  render() {
    const paramsDonViChuaChuyenPhongBan = () => {
      if (this.props.item.donVi.tenDonVi === 'Đơn chưa chuyển phòng ban') {
        return '&isPhongBanChuaChuyenDon=true'
      }
      return ''
    }
    return (
      <tr>
        <td>{this.props.count}</td>
        <td className="list-items-table">
          { 
              <div
                className={classnames('', {
                  'ml20': !this.props.item.isDonViCha ,
                  'ml40': (get(this.props.item, 'donVi.capHienThi') === 2 && !this.props.isSearchDonVi) || (get(this.props.item, 'donVi.capHienThi') === 1 && this.props.isSearchDonVi ),
                  'ml60': (get(this.props.item, 'donVi.capHienThi') === 2 && this.props.isSearchDonVi)
                })}>
                {this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''}
              </div>
          }
        </td>
        <td className="txt-center">
          {
            this.props.item.trongKy > 0 && !this.props.item.isDonViCha ?
              <Link className="black-val txt-underline" to={`/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=${get(this.props.item, 'donVi.id')}&ky=TRONGKY${paramsDonViChuaChuyenPhongBan()}`}>{ this.props.item.trongKy || 0 }</Link>
            :
              <span className="black-val">{ this.props.item.trongKy || 0 }</span>
          }
        </td>
        <td className="txt-center">
          {
            this.props.item.kyTruoc > 0 && !this.props.item.isDonViCha ?
            <Link className="black-val txt-underline" to={`/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=${get(this.props.item, 'donVi.id')}&ky=KYTRUOC${paramsDonViChuaChuyenPhongBan()}`}>{ this.props.item.kyTruoc || 0 }</Link>
            :
              <span className="black-val">{ this.props.item.kyTruoc || 0 }</span>
          }
        </td>
        <td className="txt-center">
          <span className="black-val">{ this.props.item.tongSo || 0 }</span>
        </td>
        <td className="txt-center">
          {
            this.props.item.dangXuLy && this.props.item.dangXuLy.tong > 0 && !this.props.item.isDonViCha ?
              <Link className="black-val txt-underline" to={`/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=${get(this.props.item, 'donVi.id')}&trangThaiDon=DANG_XU_LY&trangThaiDon=DANG_GIAI_QUYET${paramsDonViChuaChuyenPhongBan()}`}>{ (this.props.item.dangXuLy && this.props.item.dangXuLy.tong) || 0 }</Link>
            :
              <span className="black-val">{ (this.props.item.dangXuLy && this.props.item.dangXuLy.tong) || 0 }</span>
          }
        </td>
        <td className="txt-center">
          {
            this.props.item.daXuLy && this.props.item.daXuLy.tong > 0 && !this.props.item.isDonViCha ?
              <Link className="black-val txt-underline" to={`/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=${get(this.props.item, 'donVi.id')}&trangThaiDon=DA_XU_LY&trangThaiDon=DA_GIAI_QUYET${paramsDonViChuaChuyenPhongBan()}`}>{ (this.props.item.daXuLy && this.props.item.daXuLy.tong) || 0 }</Link>
            :
              <span className="black-val">{ (this.props.item.daXuLy && this.props.item.daXuLy.tong) || 0 }</span>
          }
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/datatable/RowItemTheoDoiDonDocTheoKy.jsx